import React from "react";
import moment from "moment-timezone";
import {
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  AreaChart,
  Area,
  ReferenceLine,
  ReferenceArea,
  Label,
} from "recharts";

// Memoized custom tick component for XAxis
const CustomXAxisTick = React.memo(({ x, y, payload, dark }) => {
  // Format the time using moment.js
  const formattedTime = moment(payload.value).format("HH:mm Do");
  return (
    <text
      x={x}
      y={y}
      dy={8}
      textAnchor="middle"
      fill={dark ? "#f3f3f3" : "#666"}
      fontSize={10}
      stroke={dark ? "#f3f3f3" : ""}
      strokeWidth={0.5}
    >
      {formattedTime === "Invalid date" ? "" : formattedTime}
    </text>
  );
});

// Memoized custom tick component for YAxis
const CustomYAxisTick = React.memo(({ x, y, payload, exponential, dark }) => {
  return (
    <text
      x={x}
      y={y}
      dy={-3}
      fill={dark ? "#f3f3f3" : "#666"}
      textAnchor="middle"
      fontSize={10}
      stroke={dark ? "#f3f3f3" : ""}
      strokeWidth={0.5}
    >
      {payload.value > 1 && exponential
        ? payload.value.toExponential()
        : payload.value}
    </text>
  );
});

const LineChart = ({ dataList, dark, aspect, i, lines, areas, version=1 }) => {
  const { color, unit, exponential, data, label, name, x, y } = dataList;

  return (
    <>
      {version === 1 ? (
        <ResponsiveContainer width={"100%"} aspect={aspect}>
          <AreaChart
            data={data}
            margin={{ top: 10, right: 30, bottom: 10, left: -20 }}
          >
            <defs>
              <linearGradient id={name} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.8} />
                <stop offset="95%" stopColor={color} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="8 8" />
            <XAxis
              dataKey={x ? x : "time"}
              interval={data.length > 500 && 300}
              tick={<CustomXAxisTick dark={dark} />}
              tickFormatter={(unixTime) => {
                const formattedTime = moment(unixTime).format("HH:mm Do");
                return formattedTime === "Invalid date" ? "" : formattedTime;
              }}
            />
            <YAxis
              tick={<CustomYAxisTick exponential={exponential} dark={dark} />}
              tickFormatter={(tick) =>
                tick > 1 && exponential ? tick.toExponential() : tick
              }
            />
            <Tooltip
              wrapperClassName="navbar-bg"
              labelFormatter={(value) => {
                return `label: ${moment(value).format("HH:mm Do")}`;
              }}
            />
            <Legend
              verticalAlign="top"
              payload={[
                {
                  value: `${label} ${
                    unit ? "(" + unit.toLowerCase() + ")" : ""
                  }`,
                  type: "line",
                  id: `ID0${i}`,
                  color: color,
                },
              ]}
              wrapperStyle={{
                fontSize: "12px",
                marginTop: "-2px",
                marginLeft: "25px",
              }}
            />
            <Area
              type="monotone"
              dataKey={y ? y : "data"}
              stroke={color}
              fillOpacity={1}
              fill={`url(#${name})`}
              dot={false}
            />
            {lines?.map((line, i) => (
              <ReferenceLine
                key={i} // Added key prop
                y={line.value}
                stroke={line.color}
                label={
                  <Label
                    fontWeight="bold"
                    value={line.label}
                    fill={dark ? "white" : "black"}
                  />
                }
              />
            ))}
            {areas?.map((area, i) => (
              <ReferenceArea
                key={i} // Added key prop
                y1={area.y1}
                y2={area.y2}
                stroke={area.color}
                strokeWidth={2}
                label={
                  <Label
                    fontWeight="bold"
                    value={area.label}
                    fill={dark ? "white" : "black"}
                  />
                }
              />
            ))}
          </AreaChart>
        </ResponsiveContainer>
      ) : (
        <ResponsiveContainer width={"100%"} aspect={aspect}>
          <AreaChart
            data={data}
            margin={{ top: 10, right: 30, bottom: 10, left: -20 }}
          >
            <defs>
              <linearGradient id={name} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.8} />
                <stop offset="95%" stopColor={color} stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis
             hide
            />
            <YAxis
             hide
            />
           
            <Area
              type="monotone"
              dataKey={y ? y : "data"}
              stroke={color}
              fillOpacity={1}
              fill={`url(#${name})`}
              dot={false}
            />
          
          </AreaChart>
        </ResponsiveContainer>
      )}
    </>
  );
};

export default LineChart;
